import React from 'react';

import ContainedRoulette from '../front/ContainedRoulette';

const RouletteLayer = (props) => {
	const is_demo = props?.is_demo ?? false;
	var new_props = Object.assign({}, {...props});
	if(new_props.is_export != undefined) delete new_props.is_export;
	if(new_props.is_builder != undefined) delete new_props.is_builder;

	if(new_props.stage != undefined && new_props.stage.bg_image != undefined) new_props.bg_image = new_props.stage.bg_image;

	return (
		<aside class={'gui_game_layer is_fullscreen' + ((is_demo) ? ' relative_to_container' : '')} style={(!is_demo) ? { zIndex:'999999' } : null}>
			<ContainedRoulette
				{...new_props}
			/>
		</aside>
	);
}

export default RouletteLayer;